/* unplugin-vue-components disabled */import { ElIcon as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56ebeca8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sidebar"
};
const _hoisted_2 = {
  class: "menus"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "name"
};
import Logo from './logo.vue';
import User from './user.vue';
import Home from '~icons/custom/home';
import Pack from '~icons/custom/pack';
import Operate from '~icons/custom/operate';
import Popularize from '~icons/custom/popularize';
import Data from '~icons/custom/data';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const appStore = useAppStore();
    const gameInfo = computed(() => appStore.gameInfo);
    const sidebar = [{
      name: '主页',
      icon: Home,
      path: '/home'
    }, {
      name: '出包',
      icon: Pack,
      path: '/pack',
      role: 'pack'
    }, {
      name: '运营',
      icon: Operate,
      path: '/operate',
      role: 'operate'
    }, {
      name: '推广',
      icon: Popularize,
      path: '/popularize',
      role: 'popularize'
    }, {
      name: '数据',
      icon: Data,
      path: '/data-center',
      role: 'dataCenter'
    }];
    const router = useRouter();
    const handleClick = item => {
      // activePath.value = item.path;
      if (gameInfo.value.Id) {
        if (item.path === '/pack' && appStore.gameType === 'miniapp' && router.hasRoute('MiniSdk')) {
          router.push({
            name: 'MiniSdk'
          });
        } else {
          router.push(item.path);
        }
      } else if (item.path === '/home') {
        router.push(item.path);
      }
    };
    const disabled = path => {
      return !gameInfo.value.Id && path !== '/home';
    };
    const route = useRoute();
    const activePath = computed(() => {
      const {
        matched
      } = route;
      if (matched.length) {
        return matched[1].path.replace('/:page*', '');
      }
      return '';
    });
    return (_ctx, _cache) => {
      const _component_el_icon = __unplugin_components_0;
      const _directive_has = _resolveDirective("has");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Logo), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(sidebar, item => {
        return _withDirectives(_createElementVNode("div", {
          key: item.path,
          class: _normalizeClass(['menu', _unref(activePath) === item.path ? 'active' : '', disabled(item.path) ? 'disabled' : '']),
          onClick: $event => handleClick(item)
        }, [_createVNode(_component_el_icon, {
          size: 24,
          color: disabled(item.path) ? '#6389F9' : _unref(activePath) === item.path ? ' #fff' : '#C5D3FC'
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))]),
          _: 2
        }, 1032, ["color"]), _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1)], 10, _hoisted_3), [[_directive_has, item.role]]);
      }), 64))]), _createVNode(User)]);
    };
  }
});